import { Spin } from 'antd';
import { useEffect } from 'react';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { db } from 'technical/db';
import Flex from 'ui/flex';

interface Props {
  children: React.ReactNode;
}

function AppBootstrapper({ children }: Props) {
  const { appBootstraped } = useAppContext();

  useEffect(() => {
    db.open();
  }, []);

  return appBootstraped ? (
    (children as React.ReactElement)
  ) : (
    <Flex
      alignItems="center"
      justify="center"
      style={{ flex: 1, height: '100vh' }}
    >
      <Spin size="large" />
    </Flex>
  );
}

export default AppBootstrapper;
